import { Component, Input, ViewChild } from '@angular/core';
import { MatMenu } from '@angular/material/menu';
import { NavItem } from '@app/shared/models/nav-item.model';

@Component({
    selector: 'app-header-menu',
    templateUrl: './header-menu.component.html',
    styleUrls: ['./header-menu.component.scss'],
    standalone: false,
})
export class HeaderMenuComponent {
    @Input() items: NavItem[];
    @Input() align: string;
    @Input() isMobile: boolean;
    @ViewChild('childMenu', { static: true }) public childMenu: MatMenu;

    executeCommand(item: NavItem): void {
        item && item.command(item);

        if (this.childMenu.parentMenu) {
            this.childMenu.parentMenu.close.emit();
        }
    }
}
